import StrategyBuildings from '@/models/strategy/StrategyBuildings'
import StrategyTools from '@/models/strategy/StrategyTools'
import StrategyStuffs from '@/models/strategy/StrategyStuffs'
import StrategyStaff from '@/models/strategy/StrategyStaff'
import StrategyTrainings from '@/models/strategy/StrategyTrainings'
import StrategyOffers from '@/models/strategy/StrategyOffers'
import StrategyContracts from '@/models/strategy/StrategyContracts'
import StrategyCommunications from '@/models/strategy/StrategyCommunications'
import StrategyLoans from '@/models/strategy/StrategyLoans'
import StrategySupplier from '@/models/strategy/StrategySupplier'

/**
 * Registre des domaines d'une Strategy.
 * La clé est le nom utilisé côté application (props de vues, agrégats, `subToData`).
 */
export const STRATEGY_DOMAINS = {
  buildings: StrategyBuildings,
  tools: StrategyTools,
  stuffs: StrategyStuffs,
  staff: StrategyStaff,
  trainings: StrategyTrainings,
  offers: StrategyOffers,
  contracts: StrategyContracts,
  communications: StrategyCommunications,
  loans: StrategyLoans,
  supplier: StrategySupplier,
}

export const STRATEGY_DOMAIN_KEYS = Object.keys(STRATEGY_DOMAINS)

export const STRATEGY_DOMAIN_CLASSES = Object.values(STRATEGY_DOMAINS)

export default STRATEGY_DOMAINS
